import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import {
  storageLocationIdFormat,
  taskIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const createCycleCount = {
  name: "createCycleCount" as const,
  input: z.object({
    name: z.string().min(1),
    locationId: locationIdFormat.schema,
    assignedUserId: z.string().optional(),
    assignedRole: z.string().optional(),
    productIds: z.array(productIdFormat.schema).default([]),
    storageLocationIds: z.array(storageLocationIdFormat.schema).default([]),
    dueAt: z.coerce.date().nullish(),
  }),
  output: z.object({ taskId: taskIdFormat.schema }),
};
